import { render, staticRenderFns } from "./UsersChangeStatus.vue?vue&type=template&id=84f91f4c"
import script from "./UsersChangeStatus.vue?vue&type=script&lang=ts"
export * from "./UsersChangeStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports